var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { BigNumber } from "ethers";
import React from "react";
import { defaultStakingAccountsData, defaultStakingSubgraphData, } from "../models/staking";
import { defaultV2VaultPriceHistoriesData, defaultVaultAccountsData, defaultVaultActivitiesData, defaultVaultsData, } from "../models/vault";
import useFetchGovernanceSubgraphData from "./useFetchGovernanceSubgraphData";
import useFetchVaultSubgraphData from "./useFetchVaultSubgraphData";
export var defaultVaultSubgraphData = {
    vaults: defaultVaultsData,
    vaultAccounts: defaultVaultAccountsData,
    vaultActivities: defaultVaultActivitiesData,
    balances: [],
    transactions: [],
    vaultPriceHistory: defaultV2VaultPriceHistoriesData,
    stakingPools: defaultStakingSubgraphData,
    stakingAccounts: defaultStakingAccountsData,
    loading: true,
};
export var defaultGovernanceSubgraphData = {
    rbnTokenDistributedLg5: BigNumber.from(0),
    transactions: [],
    loading: true,
};
export var SubgraphDataContext = React.createContext({
    vaultSubgraphData: defaultVaultSubgraphData,
    governanceSubgraphData: defaultGovernanceSubgraphData,
});
export var SubgraphDataContextProvider = function (_a) {
    var children = _a.children;
    var vaultSubgraphData = useFetchVaultSubgraphData();
    var governanceSubgraphData = useFetchGovernanceSubgraphData();
    return (_jsx(SubgraphDataContext.Provider, __assign({ value: {
            vaultSubgraphData: vaultSubgraphData,
            governanceSubgraphData: governanceSubgraphData,
        } }, { children: children }), void 0));
};
//# sourceMappingURL=subgraphDataContext.js.map